import React from "react";
import PropTypes from "prop-types";

// Assets
import facebook from "assets/images/facebook-color.svg";
import google from "assets/images/google-color.svg";

// Utils
import i18n from "utils/i18n";

// Style
import { LinkButton, Image, Text } from "./SocialButton.style";

const social = {
  google: {
    icon: google,
    link: `${process.env.REACT_APP_API_URL}/auth/google`,
    text: i18n.t("SocialButton.Google.Login")
  },
  facebook: {
    icon: facebook,
    link: `${process.env.REACT_APP_API_URL}/auth/facebook`,
    text: i18n.t("SocialButton.Facebook.Login")
  }
};

export const SocialButton = ({ type }) => {
  const socialObject = social[type];
  const { link, icon, text } = socialObject;
  return (
    <LinkButton href={link} data-cy={`social-${type}`} title={text}>
      <Image src={icon} alt={`Icon - ${type}`} />
      <Text>{text}</Text>
    </LinkButton>
  );
};

SocialButton.propTypes = {
  type: PropTypes.string
};
